import { render, staticRenderFns } from "./Calendar-Setting.vue?vue&type=template&id=c2808812&scoped=true"
import script from "./Calendar-Setting.vue?vue&type=script&lang=js"
export * from "./Calendar-Setting.vue?vue&type=script&lang=js"
import style0 from "./Calendar-Setting.vue?vue&type=style&index=0&id=c2808812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2808812",
  null
  
)

export default component.exports